var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { useSetAtom } from 'jotai';
import React, { useState } from 'react';
import { View } from 'react-native';
import { accessTokenAtom } from '@/atoms/Auth';
import { SccButton } from '@/components/atoms';
import { font } from '@/constant/font';
import useAppComponents from '@/hooks/useAppComponents';
import WithdrawConfirmBottomSheet from '@/modals/WithdrawConfirmBottomSheet/WithdrawConfirmBottomSheet';
import useNavigation from '@/navigation/useNavigation';
import ToastUtils from '@/utils/ToastUtils';
export default function BottomButtons() {
    const { api } = useAppComponents();
    const navigation = useNavigation();
    const setAccessToken = useSetAtom(accessTokenAtom);
    const [isConfirmVisible, setIsConfirmVisible] = useState(false);
    function logout() {
        return __awaiter(this, void 0, void 0, function* () {
            setAccessToken(null);
            ToastUtils.show('로그아웃했습니다');
            navigation.reset({
                index: 0,
                routes: [{ name: 'Login' }],
            });
        });
    }
    function withdraw() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield api.deleteUserPost({});
                ToastUtils.show('탈퇴했습니다');
                setIsConfirmVisible(false);
                setAccessToken(null);
                navigation.reset({
                    index: 0,
                    routes: [{ name: 'Login' }],
                });
            }
            catch (error) {
                ToastUtils.showOnApiError(error);
            }
        });
    }
    return (_jsxs(View, { className: "gap-[10px] px-5 pt-5 pb-3", children: [_jsx(SccButton, { text: "\uB85C\uADF8\uC544\uC6C3", textColor: "gray80", buttonColor: "gray15", fontFamily: font.pretendardMedium, onPress: logout, elementName: "setting_logout", style: { borderRadius: 14 } }), _jsx(SccButton, { text: "\uD0C8\uD1F4\uD558\uAE30", textColor: "gray50", buttonColor: "white", fontFamily: font.pretendardMedium, onPress: () => setIsConfirmVisible(true), elementName: "setting_withdraw" }), _jsx(WithdrawConfirmBottomSheet, { name: "deleteAccount", isVisible: isConfirmVisible, onConfirmButtonPressed: withdraw, onCloseButtonPressed: () => setIsConfirmVisible(false) })] }));
}
